module.exports = __webpack_public_path__ + "img/logo.aec72806.svg";